import { render, staticRenderFns } from "./NewDocumentRelatedSearch.vue?vue&type=template&id=ae80b144&"
import script from "./NewDocumentRelatedSearch.vue?vue&type=script&lang=js&"
export * from "./NewDocumentRelatedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae80b144')) {
      api.createRecord('ae80b144', component.options)
    } else {
      api.reload('ae80b144', component.options)
    }
    module.hot.accept("./NewDocumentRelatedSearch.vue?vue&type=template&id=ae80b144&", function () {
      api.rerender('ae80b144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewDocumentRelated/NewDocumentRelatedSearch.vue"
export default component.exports